import root from './root';
import nav from './nav';
import chat from './chat';
import users from './users';
import notifications from './notifications';
import search from './search';
import media from './media';

export default {
	namespaced: true,
	modules: {
		root, nav, chat, users, notifications, search, media
	},
	actions: {
		async initAPI({dispatch}) {
			let url = window.location.href
			//have to do this instead of using router as it hasn't loaded yet and doesn't register difference
			let ifSSORedirect = url.includes('/signin') || url.includes('/silent-refresh') || url.includes('/guest-signin')
			await dispatch('auth/initOidc', ifSSORedirect)
		},

		async genericHandler({dispatch}, [action, data, callback]){
			let res = await dispatch(action, data).catch(e => console.error(e));

			if(res?.success) return res;

			if(callback) callback()

			return {error: res};
		}
	}
}
